import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CourseCard = ({ course, onEnroll, onViewDetails }) => {
  return (
    <div className="bg-card rounded-lg shadow-warm overflow-hidden hover:shadow-lg transition-smooth">
      <div className="relative h-48 bg-gradient-to-br from-primary/20 to-primary/5 flex items-center justify-center">
        <Icon name={course.icon} size={64} color="var(--color-primary)" />
        <div className="absolute top-4 right-4 bg-primary/10 text-primary px-3 py-1 rounded-full text-sm font-semibold">
          {course.level}
        </div>
      </div>

      <div className="p-6">
        <h3 className="text-lg font-semibold text-foreground mb-2">{course.title}</h3>
        <p className="text-muted-foreground text-sm mb-4">{course.description}</p>

        <div className="space-y-3 mb-6">
          <div className="flex items-center gap-3 text-sm text-foreground">
            <Icon name="User" size={16} color="var(--color-primary)" />
            <span className="font-medium">{course.instructor}</span>
          </div>
          <div className="flex items-center gap-3 text-sm text-foreground">
            <Icon name="Clock" size={16} color="var(--color-primary)" />
            <span>{course.duration}</span>
          </div>
          <div className="flex items-center gap-3 text-sm text-foreground">
            <Icon name="Users" size={16} color="var(--color-primary)" />
            <span>{course.students} students enrolled</span>
          </div>
        </div>

        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-1">
            {[...Array(5)].map((_, i) => (
              <Icon
                key={i}
                name="Star"
                size={14}
                color={i < course.rating ? 'var(--color-primary)' : 'var(--color-border)'}
              />
            ))}
            <span className="text-xs text-muted-foreground ml-2">({course.reviews} reviews)</span>
          </div>
          <span className="text-lg font-bold text-primary">${course.price}</span>
        </div>

        <div className="space-y-2">
          <Button
            onClick={() => onEnroll(course.id)}
            variant="default"
            fullWidth
            iconName="ArrowRight"
            iconPosition="right"
          >
            Enroll Now
          </Button>
          <Button
            onClick={() => onViewDetails && onViewDetails(course.id)}
            variant="outline"
            fullWidth
            iconName="ExternalLink"
            iconPosition="right"
          >
            View Details
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CourseCard;
